.container {
}

.container > input {
    width: 150px;
}

.container--full-width > input {
    width: 100%;
}
